module.exports = __webpack_public_path__ + "media/packs/static/fonts/interUI/medium-f7f38c3286a3172a7819b07f3132756a.woff";